import { Link as ChakraLink, LinkProps as ChakraLinkProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Link as ReactRouterLink } from "react-router";

interface ProjectLinkProps extends ChakraLinkProps {
  to?: string;
  queryParams?: string;
}

export function RanaLink({
  to,
  queryParams,
  children,
  ...rest
}: PropsWithChildren<ProjectLinkProps>) {
  return (
    <ChakraLink
      to={`${to ?? window.location.pathname}${queryParams ? "?" + queryParams : ""}`}
      as={ReactRouterLink}
      {...rest}
    >
      {children}
    </ChakraLink>
  );
}
